import { useState } from "react";
import { toast } from "sonner";
import axios from "./axios";

export const useGetSpinTheWheel = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const getSpinTheWheel = async (id, token) => {
    setLoading(true);
    try {
      const res = await axios.get(`audiences/spin-the-wheel/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });

      if (res.status === 200) {
        setLoading(false);
        setData(res?.data);
        return res.data;
      }
    } catch (err) {
      setLoading(false);
      console.error("Brand Prizes Error:", err);
      toast.error(
        err?.response?.data?.message || "Failed to fetch brand prizes"
      );
    }
  };

  return { getSpinTheWheel, data, setData, loading, setLoading };
};
